export const HOST = process.env.REACT_APP_HOST_API;
export const VERSION = 'api/v1/';

const APP_URL = {
    GUARDARFORMWEB: `${HOST}${VERSION}app/request/sendEmail`,
    VALIDARRECAPTCHA: `${HOST}${VERSION}app/request/validarRecaptcha`,
}

export default APP_URL
